import JSONLight from "../assets/dsls-logos/json_L.png";
import JSONDark from "../assets/dsls-logos/json_D.png";


/**
 * Retrieves the constants for the json  language.
 * @returns {Promise<Object>} The constants object.
 */
export const getJSONConstants = async () => {
    const constants = {
        enabled: true,
        _id: "json",
        name: "JSON",
        short: "json",
        description: "JSON is a lightweight data-interchange format that is easy for humans to read and write, and easy for machines to parse and generate.",
        logoUrl: JSONLight,
        logoUrlDark: JSONDark,
        insertableEntities: {},
        shortDescription: "",
        documentation: "",
        subtypes: [],
        hasValidation: true,
        type: "Textual",
        canTransformTo: ["eml"],
        mustImport: [],
        canImport: [],
        supportsGeneration: false,
        supportsDeployment: false,
        deploymentStoppable: false,
        generationLanguage: "",
        generations: [],
        generationsOutputMap: {
            Default: "string",
        },
        keywords: [],
        llmSupport: false,
        tags: ["Textual"],
        initiallyCollapsed: false,
        experimental: false,
    };
    return constants;
};
